<template>
    <md-button v-if="wordColor(word, 'white')" class="md-raised col">
      {{ word.text }}
    </md-button>
    <md-button v-else-if="wordColor(word, 'blue')" class="md-raised col md-primary">
      {{ word.text }}
    </md-button>
    <md-button v-else class="md-raised col md-accent">
      {{ word.text }}
    </md-button>
</template>

<script>
export default {
  name: 'GameBoardButton',
  data: () => ({
    sending: false,
    isSpyMaster: false,
    showSpyMasterToolTip: false
  }),
  props: ["word"],
  methods: {
   wordColor(word, color) {
     return this.isSpyMaster === false || word.color === color;
   },
   buttonClicked(word){
     if(this.isSpyMaster === false){
      this.sending = true;
      this.$emit("word-selected",word.text);
      this.sending = false;
     } else {
       this.showSpyMasterToolTip = true;
       // TODO set interval to close the time this tool tip is in existance.
       // TODO extract tool tip from this button.
     }
   }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>